<template>
  <div ref="mask" :class="{'mask': true, 'leave': leave, 'show': show }" @touchmove.prevent @scroll.prevent @click="leave = !leave">
    <div class="dialog" @click.stop>
      <!-- <i class="dialog_close" @click="leave = !leave"></i> -->
      <div class="dialog_body">
        <img src="../assets/figure.png">
        <p class="app_info text1">{{ text1 }}</p>
        <p class="app_info text2">{{ text2 }}</p>
        <p class="app_info text3">{{ text3 }}</p>
      </div>
      <div class="dialog_foot">
        <button @click="leave = !leave">{{ btnText }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
    text1: String,
    text2: String,
    text3: String,
    btnText: String
  },
  data () {
    return {
      leave: false
    }
  },
  methods: {
    hide () {
      if (this.leave === true) {
        this.leave = false
        this.$emit('hideDialog')
      }
    },
    btnEvent () {
      this.$emit('btnEvent') 
    }
  },
  mounted () {
    this.$refs.mask.addEventListener('animationend', this.hide)
  }
}
</script>
<style scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  animation: mask-in 0.5s 0.1s both;
  display: none;
}
.mask.show {
  display: block;
}
.mask.leave {
  animation: mask-out 0.5s 0.1s both;
}
.mask.leave>.dialog {
  animation: animate-out 0.5s 0.1s both;
}
.dialog {
  width: 20em;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: .8em;
  box-shadow: 0 4px 4px rgba(0, 0, 0, .1);
  text-align: center;
  overflow: hidden;
  animation: animate-in 0.5s 0.1s both;
  padding: 2em 0 1em;
  background-color: #fff;
}
.dialog_close {
  width: .8em;
  height: .8em;
  position: absolute;
  right: 1em;
  top: .6em;
  background-image: url('../assets/mask-close.png')
}
.dialog_head {
  padding: 1em;
}
.dialog_body {
  padding: 0 1em .5em;
}
.dialog_body img {
  width: 55%;
}
.dialog_body p {
  line-height: 2em;
}
.app_info {
  color: #282468;
  /* margin: .5em 0 1em; */
  font-weight: 600;
}
.app_info.text1 {
  font-size: 1.2em;
  margin-bottom: 0;
}
.dialog_foot button{
  width: 50%;
  padding: .5em 0;
  color: #fff;
  border-radius: 3em;
  background: linear-gradient(60deg, #3866ef, #523fec);
}
@keyframes animate-in {
  0%{ transform:translate(-50%,-70%); opacity: 0 }
	100%{ transform:translate(-50%,-50%); opacity: 1 }
}
@keyframes animate-out {
  0%{ transform:translate(-50%,-50%); opacity: 1 }
	100%{ transform:translate(-50%,-70%); opacity: 0 }
}
@keyframes mask-in {
  0%{ opacity: 0 }
	100%{ opacity: 1 }
}
@keyframes mask-out {
  0%{ opacity: 1 }
	100%{ opacity: 0 }
}
</style>